export default __webpack_public_path__ + "static/data_port_w.df6cfe12478057d9cd97865baaa226f3.png";